import connect from 'react-redux/es/connect/connect';
import { setLoggedInUser } from '../../actions/user';
import SignUpModal from '../../components/modals/SignUpModal';

const mapDispatchToProps = dispatch => ({
    setLoggedInUser: user => {
        dispatch(setLoggedInUser(user));
    }
});

export default connect(() => {
    return {};
}, mapDispatchToProps)(SignUpModal);
